const show = {
  namespaced: true,

  state: {},

  getters: {},

  mutations: {},

  actions: {},
};

export default show;
